export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/@ngx-translate/http-loader/index.js
// module id = ../../../../@ngx-translate/http-loader/index.js
// module chunks = 11